(() => {
  if (window.__sunglassUpCareKitInitialized) return;
  window.__sunglassUpCareKitInitialized = true;

  const SECTION_IDS = [
    'cart-items',
    'cart-footer',
    'cart-item-count',
    'cart-live-region'
  ];

  let orphanCleanupInFlight = false;

  function getRoutes() {
    return {
      add:
        window.theme?.routes?.cart_add_url ||
        `${window.Shopify?.routes?.root || '/'}cart/add`,
      change:
        window.theme?.routes?.cart_change_url ||
        `${window.Shopify?.routes?.root || '/'}cart/change`
    };
  }

  async function cartRequest(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        ...payload,
        sections: SECTION_IDS,
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok || data.status === 422) {
      throw new Error(
        data.description ||
        data.message ||
        window.theme?.strings?.cartError ||
        'Impossibile aggiornare il carrello.'
      );
    }

    if (!data.sections) {
      throw new Error(
        window.theme?.strings?.cartError ||
        'Impossibile aggiornare il carrello.'
      );
    }

    return data;
  }

  function dispatchCartUpdate(response) {
    document.body.dispatchEvent(
      new CustomEvent('baseline:cart:cartqtychange', {
        bubbles: true,
        detail: {
          response,
          originalTarget: null
        }
      })
    );
  }

  function setLoading(container, input, loading) {
    if (container) {
      container.classList.toggle('is-loading', loading);
    }

    if (input) {
      input.disabled = loading;
    }
  }

  function showError(container, message) {
    if (!container) return;

    const errorElement =
      container.querySelector('[data-care-kit-error]');

    if (!errorElement) return;

    if (!message) {
      errorElement.textContent = '';
      errorElement.hidden = true;
      return;
    }

    errorElement.textContent = message;
    errorElement.hidden = false;
  }

  async function addCareKit(input) {
    const variantId = Number(input.dataset.variantId);

    if (!variantId) {
      throw new Error(
        window.theme?.strings?.cartAddError ||
        'Care Kit non disponibile.'
      );
    }

    return cartRequest(
      getRoutes().add,
      {
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      }
    );
  }

  async function removeCareKit(input) {
    const itemKey = input.dataset.itemKey;

    if (!itemKey) {
      throw new Error(
        window.theme?.strings?.cartError ||
        'Impossibile rimuovere il Care Kit.'
      );
    }

    return cartRequest(
      getRoutes().change,
      {
        id: itemKey,
        quantity: 0
      }
    );
  }

  async function handleToggle(input) {
    const container = input.closest('[data-care-kit]');
    const intendedState = input.checked;

    setLoading(container, input, true);
    showError(container, '');

    try {
      const response = intendedState
        ? await addCareKit(input)
        : await removeCareKit(input);

      dispatchCartUpdate(response);
    } catch (error) {
      input.checked = !intendedState;

      showError(
        container,
        error?.message ||
        window.theme?.strings?.cartError ||
        'Impossibile aggiornare il carrello.'
      );

      console.error(
        'SunglassUp Care Kit:',
        error
      );
    } finally {
      setLoading(container, input, false);
    }
  }

  async function cleanupOrphan() {
    if (orphanCleanupInFlight) return;

    const orphan =
      document.querySelector('[data-care-kit-orphan]');

    if (!orphan) return;

    const itemKey = orphan.dataset.itemKey;

    if (!itemKey) return;

    orphanCleanupInFlight = true;

    try {
      const response = await cartRequest(
        getRoutes().change,
        {
          id: itemKey,
          quantity: 0
        }
      );

      dispatchCartUpdate(response);
    } catch (error) {
      console.error(
        'SunglassUp Care Kit dependency:',
        error
      );
    } finally {
      orphanCleanupInFlight = false;
    }
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest(
      '[data-care-kit-toggle]'
    );

    if (!input) return;

    handleToggle(input);
  });

  function scheduleOrphanCleanup() {
    window.setTimeout(cleanupOrphan, 0);
  }

  window.addEventListener(
    'baseline:cart:afteradditem',
    scheduleOrphanCleanup
  );

  window.addEventListener(
    'baseline:cart:cartqtychange',
    scheduleOrphanCleanup
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleOrphanCleanup
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleOrphanCleanup,
      { once: true }
    );
  } else {
    scheduleOrphanCleanup();
  }
})();